
namespace GeniuzPOS.Lookups {

    @Serenity.Decorators.registerClass()
    export class LookupTxtColorDialog extends Serenity.EntityDialog<LookupTxtColorRow, any> {
        protected getFormKey() { return LookupTxtColorForm.formKey; }
        protected getIdProperty() { return LookupTxtColorRow.idProperty; }
        protected getLocalTextPrefix() { return LookupTxtColorRow.localTextPrefix; }
        protected getNameProperty() { return LookupTxtColorRow.nameProperty; }
        protected getService() { return LookupTxtColorService.baseUrl; }
        protected getDeletePermission() { return LookupTxtColorRow.deletePermission; }
        protected getInsertPermission() { return LookupTxtColorRow.insertPermission; }
        protected getUpdatePermission() { return LookupTxtColorRow.updatePermission; }

        protected form = new LookupTxtColorForm(this.idPrefix);

    }
}